import { useEffect, useState } from 'react';
import del from '../../assets/icons/delete.svg'
import edit from '../../assets/icons/edit.svg'
import AddPropertyModal from '../../components/AddPropertyModal';
import { useNavigate } from 'react-router-dom';
import useProperties from '../../utils/useProperties';

const Properties = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenId, setIsOpenId] = useState<Number>()
  const [editOpen, setEditOpen] = useState(false);
  const navigate = useNavigate()

  

  const { loading: Ploading, properties } = useProperties()


  const emailStored = localStorage.getItem('akjodem_email');
  const loggedInStored = localStorage.getItem('akjodem_isLoggedIn');
  
  useEffect(() => {
    if (!emailStored && !loggedInStored) {
      navigate('/login');
    }
  }, []);


  const handleClick = (e: any, index: number) => {
    setEditOpen(true)
    setIsOpenId(index)
  }

  const handleDelete = (id: string) => {


    const isConfirmed = window.confirm("Are you sure you want to delete this property?");

    if (!isConfirmed) {
      return; // If the user cancels, stop the deletion process
    }
    fetch('https://akjodem.com/deleteProperty.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id,
      }),
    })
      .then((response) => response.json())  // Parse the JSON response
            .then((data) => {
        if (data.status === 'success') {
          alert('Property deleted successfully!');
          window.location.reload()
        } else {
          alert('Failed to delete property');
        }
      })
      .catch((error) => {
        alert('An error occurred: ' + error.message);
      })
      

  };

  return (
    <>
      {loggedInStored &&
        <main className="flex-grow p-6">
          <h2 className="mb-6 font-semibold text-gray-800 text-2xl">Manage Properties</h2>
          <button onClick={() => setIsOpen(true)} className="bg-green-500 hover:bg-green-600 mr-2 px-3 py-1 rounded-lg text-white">
            Add Property
          </button>
          <div className="bg-white shadow-md p-4 rounded-lg overflow-x-auto">
            <table className="w-full table-auto">
              <thead>
                <tr className="bg-gray-200 text-gray-700">
                  <th className="px-4 py-2 text-left">S/N</th>
                  <th className="px-4 py-2 text-left">Property Name</th>
                  <th className="hidden md:table-cell px-4 py-2 text-left">Description</th>
                  <th className="hidden md:table-cell px-4 py-2 text-left">Category</th>
                  <th className="hidden md:table-cell px-4 py-2 text-left">Type</th>
                  <th className="hidden md:table-cell px-4 py-2 text-left">Location</th>
                  <th className="px-4 py-2 text-left">Price</th>
                  <th className="hidden md:table-cell px-4 py-2 text-left">Bedrooms</th>
                  <th className="hidden md:table-cell px-4 py-2 text-left">Bathrooms</th>
                  <th className="hidden md:table-cell px-4 py-2 text-left">Sqft</th>
                  <th className="hidden md:table-cell px-4 py-2 text-left">Featured</th>
                  <th className="hidden md:table-cell px-4 py-2 text-left">Sold</th>
                  <th className="px-4 py-2 text-left">Actions</th>
                </tr>
              </thead>
              <tbody>
                {properties && properties.length > 0 ? (
                  properties.map((property, index) => (
                    <>
                      <tr className="hover:bg-gray-50 border-gray-200 border-b" key={index}>
                        <td className="px-4 py-2">{index + 1}</td>
                        <td className="px-4 py-2">{property.name}</td>
                        <td className="hidden md:table-cell px-4 py-2">{property.description}</td>
                        <td className="hidden md:table-cell px-4 py-2">{property.category}</td>
                        <td className="hidden md:table-cell px-4 py-2">{property.type}</td>
                        <td className="hidden md:table-cell px-4 py-2">{property.location}</td>
                        <td className="px-4 py-2">{Number(property.price).toLocaleString()}</td>
                        <td className="hidden md:table-cell px-4 py-2">{property.bed}</td>
                        <td className="hidden md:table-cell px-4 py-2">{property.bath}</td>
                        <td className="hidden md:table-cell px-4 py-2">{property.sqft}</td>
                        <td className="hidden md:table-cell px-4 py-2">{property.featured}</td>
                        <td className="hidden md:table-cell px-4 py-2">{property.sold}</td>
                        <td className="flex space-x-2 px-4 py-2">
                          <button onClick={(e) => handleClick(e, index)} className="bg-blue-500 hover:bg-blue-600 p-1 rounded-lg text-white">
                            <img src={edit} alt="edit icon" className="w-6" />
                          </button>
                          <button onClick={() => handleDelete(property.id)} className="bg-red-500 hover:bg-red-600 p-1 rounded-lg text-white">
                            <img src={del} alt="delete icon" className="w-6" />
                          </button>
                        </td>
                      </tr>
                      {editOpen && isOpenId === index && <AddPropertyModal isOpen={isOpen} setIsOpen={setIsOpen} setEditOpen={setEditOpen} property={property} />}
                    </>
                  ))
                ) : (
                  <tr>
                    <td colSpan={10} className="py-4 text-center">No properties found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

        </main>
      }
      {isOpen && <AddPropertyModal isOpen={isOpen} setIsOpen={setIsOpen} />}
    </>
  );
};

export default Properties;
